import { styled } from '@abyss/web/tools/styled';
export const ThingsToConsiderModalStyle = {
  'abyss-modal-content-container': {
    width: '784px',
    maxHeight: '90vh',
  },
  'abyss-modal-content-title': {
    fontSize: '28.83px !important',
    fontWeight: '600 !important',
    lineHeight: '36px !important',
    textAlign: 'center',
    marginTop: '100px',
  },
  'abyss-modal-body': {
    overflowY: 'auto',
    maxHeight: 'calc(90vh - 250px)',
  },
};

export const ThingsToConsiderModalStyleEni = {
  'abyss-modal-content-container': {
    width: '784px',
    maxHeight: '90vh',
  },
  'abyss-modal-content-title': {
    fontSize: '28.83px !important',
    fontWeight: '600 !important',
    lineHeight: '36px !important',
    textAlign: 'center',
    marginTop: '100px',
  },
  'abyss-modal-footer': {
    marginLeft: '-5px',
  },
  'abyss-modal-body': {
    overflowY: 'auto',
    maxHeight: 'calc(90vh - 250px)',
  },
};

export const ThingsToConsiderMobileModalStyle = {
  'abyss-modal-content-container': {
    width: '343px',
    maxHeight: '90vh',
  },
  'abyss-modal-content-title': {
    fontSize: '28.83px !important',
    fontWeight: '600 !important',
    lineHeight: '36px !important',
    textAlign: 'center',
    marginTop: '85px',
  },
  'abyss-modal-body': {
    overflowY: 'auto',
    maxHeight: 'calc(90vh - 280px)',
  },
  'abyss-modal-footer': {
    marginLeft: '-15px',
  },
};

export const ThingsToConsiderMobileModalStyleEni = {
  'abyss-modal-content-container': {
    width: '343px',
    maxHeight: '90vh',
  },
  'abyss-modal-content-title': {
    fontSize: '25.83px !important',
    fontWeight: '600 !important',
    lineHeight: '36px !important',
    textAlign: 'center',
    marginTop: '85px',
  },
  'abyss-modal-body': {
    overflowY: 'auto',
    maxHeight: 'calc(90vh - 280px)',
  },
  'abyss-modal-footer': {
    marginLeft: '-15px',
  },
};

export const ModalContent = styled('div', {
  padding: '8px 16px',
  marginTop: '8px',
});

export const MedicalAvatar = styled('div', {
  width: '70px',
  height: '70px',
  borderRadius: '50%',
  position: 'absolute',
  top: '30px',
  marginTop: '8px',
});

export const ModalSubTitle = styled('p', {
  fontSize: '18px',
  fontWeight: '400',
  lineHeight: '24px',
  textAlign: 'center',
  marginTop: '-50px',
  paddingLeft: '0px',
  color: '$gray7',
});

export const ModalHeading = styled('h3', {
  fontSize: '18px',
  fontWeight: '700',
  lineHeight: '24px',
  textAlign: 'left',
  margin: '10px 16px 10px 16px',
  paddingBottom: '0px',
  color: 'var(--abyss-psx-parcel-colors-black) !important',
});

export const ModalDataContent = styled('p', {
  margin: '0 16px',
  fontSize: '18px',
  fontWeight: '400',
  color: '$gray7',
  lineHeight: '24px',
  padding: '0px 0px 24px 0px',
});
